<template>
  <div class="q-mx-auto q-py-sm" style="max-width: 900px">
    <q-card flat bordered>
      <div class="row q-pa-md">
        <div class="col">
          <div
            class="text-body1 text-weight-bold"
            :class="this.$q.dark.mode === true ? '' : 'text-primary '"
          >
            Broker Analytics of {{ symbol }}
          </div>
        </div>
        <div v-if="tabPeriod === 'daily'" class="col">
          <q-input
            dense
            filled
            v-model="selectedDate"
            capslock
            mask="date"
            :rules="['date']"
            class="text-bold"
          >
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="selectedDate"
                @input="() => $refs.qDateProxy.hide()"
                @update:model-value="loadData(selectedDate, symbol)"
              />
            </q-popup-proxy>
            <q-icon
              name="event"
              class="text-grey text-h6 date-icon cursor-pointer q-pt-md"
            />
          </q-input>
        </div>
        <div
          v-if="tabPeriod !== 'daily'"
          class="row text-body2 text-right"
          :class="this.$q.dark.mode === true ? '' : 'text-primary '"
        >
          As of : {{ this.$store.state.market.asOf }}
        </div>
      </div>

      <q-tabs
        v-model="tabPeriod"
        dense
        outside-arrows
        mobile-arrows
        :class="
          this.$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'
        "
        active-color="white"
        :active-bg-color="this.$q.dark.mode === true ? 'grey-9' : 'blue-4'"
        :indicator-color="this.$q.dark.mode === true ? 'grey-7' : 'blue-5'"
        align="justify"
        narrow-indicator
      >
        <q-tab name="daily" label="Daily" no-caps />
        <q-tab name="weekly" label="Weekly" no-caps />
        <q-tab name="monthly" label="Monthly" no-caps />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="tabPeriod" animated>
        <q-tab-panel class="q-pa-none" :name="tabPeriod">
          <q-separator color="white" size="sm" />

          <q-tabs
            v-model="tabAction"
            dense
            outside-arrows
            mobile-arrows
            :class="
              this.$q.dark.mode === true
                ? 'bg-grey-10'
                : 'text-grey-9 bg-grey-4'
            "
            active-color="white"
            :active-bg-color="this.$q.dark.mode === true ? 'grey-9' : 'blue-4'"
            :indicator-color="this.$q.dark.mode === true ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab name="top-bought" label="Top Bought" no-caps />
            <q-tab name="top-sold" label="Top Sold" no-caps />
            <q-tab name="top-net-holding" label="Top Holding" no-caps />
            <q-tab name="top-net-released" label="Top Released" no-caps />
          </q-tabs>

          <q-separator />

          <q-tab-panels v-model="tabAction" animated>
            <q-tab-panel class="q-pa-none" :name="tabAction">
              <q-separator color="white" size="sm" />

              <q-tabs
                v-model="tabDisplay"
                dense
                outside-arrows
                mobile-arrows
                :class="
                  this.$q.dark.mode === true
                    ? 'bg-grey-10'
                    : 'text-grey-9 bg-grey-4'
                "
                active-color="white"
                :active-bg-color="
                  this.$q.dark.mode === true ? 'grey-9' : 'blue-4'
                "
                :indicator-color="
                  this.$q.dark.mode === true ? 'grey-7' : 'blue-5'
                "
                align="justify"
                narrow-indicator
              >
                <q-tab name="tabular" label="Tabular" no-caps />
                <q-tab name="bar" label="Bar Graph" no-caps />
              </q-tabs>

              <q-tab-panels class="q-mt-md" v-model="tabDisplay" animated>
                <q-tab-panel class="q-pa-none" name="tabular">
                  <q-table
                    :class="
                      this.$q.dark.mode === true
                        ? 'table-sticky-header-column-dark'
                        : 'table-sticky-header-column'
                    "
                    :rows="seriesData()"
                    :columns="
                      tabAction == 'top-bought' ||
                      tabAction == 'top-net-holding'
                        ? columnsBuy
                        : columnsSell
                    "
                    :loading="loading"
                    row-key="name"
                    :filter-method="filterBrokerAnalytics"
                    :filter="filterBroker"
                    separator="cell"
                    :pagination="{
                      rowsPerPage: 10,
                    }"
                  >
                    <template v-slot:top-left>
                      <div class="row">
                        <q-input
                          class="q-mr-md live-search"
                          bordered
                          dense
                          debounce="300"
                          v-model="filterBroker"
                          placeholder="Filter Broker"
                        >
                        </q-input>
                      </div>
                    </template>
                    <template v-slot:top-right>
                      <div class="row">
                        <q-btn
                          @click="filterBroker = ''"
                          color="dark"
                          label="Clear Filter"
                          flat
                          dense
                        >
                          <q-icon name="clear" class="q-ml-md" />
                        </q-btn>
                      </div>
                    </template>
                    <template v-slot:body-cell-symbol="props">
                      <q-td :props="props">
                        <q-item
                          dense
                          clickable
                          :to="{
                            path: '/stock-profile',
                            query: { symbol: props.value },
                          }"
                        >
                          {{ props.value }}
                        </q-item>
                      </q-td>
                    </template>
                    <template v-slot:bottom-row>
                      <q-tr
                        :class="this.$q.dark.mode ? 'bg-grey-9' : 'bg-grey-4'"
                      >
                        <q-td colspan="1">Total</q-td>
                        <q-td class="text-center">
                          {{ sumBy(seriesData(), "quantity").toFixed(2) }}
                        </q-td>
                        <q-td class="text-center">
                          {{ sumBy(seriesData(), "amount").toFixed(2) }}
                        </q-td>
                        <q-td class="text-center">
                          {{
                            (
                              sumBy(seriesData(), "amount") /
                              sumBy(seriesData(), "quantity")
                            ).toFixed(2)
                          }}
                          <!-- {{ meanBy(seriesData(), "rate").toFixed(2) }} -->
                        </q-td>
                      </q-tr>
                    </template>
                  </q-table>
                </q-tab-panel>

                <q-tab-panel class="q-pa-none" name="bar">
                  <p class="text-subtitle2 q-mx-sm">
                    Brokerwise
                    {{ tabAction.split("-").slice(-1)[0] }}
                    amount of
                    {{ selectedSymbol }}
                  </p>
                  <div id="chart-by-symbol" class="q-my-md"></div>
                </q-tab-panel>
              </q-tab-panels>
            </q-tab-panel>
          </q-tab-panels>
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import useData from "src/use/data";
import ApexChart from "apexcharts";
import { sumBy, meanBy } from "lodash";

export default {
  name: "BrokerAnalyticsComponents",
  props: {
    symbol: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const {
      netHoldingDayWise,
      netHoldingDateWise,

      netReleasedDateWise,
      netReleasedDayWise,

      buyerStockDayWise,
      buyerStockDateWise,

      sellerStockDayWise,
      sellerStockDateWise,
    } = useData();

    const store = useStore();

    const loading = ref(true);
    const selectedSymbol = ref("");
    const selectedDate = ref("");

    let netHold = ref(null);

    let netHoldDaily = ref(null);
    let netHoldWeekly = ref(null);
    let netHoldMonthly = ref(null);

    let netReleasedDaily = ref(null);
    let netReleasedWeekly = ref(null);
    let netReleasedMonthly = ref(null);

    let topBuyDaily = ref(null);
    let topBuyWeekly = ref(null);
    let topBuyMonthly = ref(null);

    let topSellDaily = ref(null);
    let topSellWeekly = ref(null);
    let topSellMonthly = ref(null);

    let elOverallChart;
    let elSymbolChart;

    const tabPeriod = ref("daily");
    const tabAction = ref("top-bought");
    const tabDisplay = ref("tabular");

    const chartInstance = ref(null);
    const overallChartInstance = ref(null);

    const columnsSell = [
      {
        name: "seller",
        label: "Seller",
        field: "seller",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "left",
      },
      {
        name: "quantity",
        label: "Quantity ( % )",
        field: "quantity",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          const percentage = (row.quantity / row.quantity_total) * 100;
          return `${parseFloat(val).toFixed(2)} (${percentage?.toFixed(2)} %)`;
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amount",
        field: "amount",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "rate",
        label: "Rate",
        field: "rate",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
    ];
    const columnsBuy = [
      {
        name: "buyer",
        label: "Buyer",
        field: "buyer",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        align: "left",
      },
      {
        name: "quantity",
        label: "Quantity ( % )",
        field: "quantity",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          const percentage = (row.quantity / row.quantity_total) * 100;
          return `${parseFloat(val).toFixed(2)}  (${percentage?.toFixed(2)} %)`;
        },
        align: "center",
      },
      {
        name: "amount",
        label: "Amount",
        field: "amount",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "rate",
        label: "Rate",
        field: "rate",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
    ];

    const filterBroker = ref("");

    const filterBrokerAnalytics = (rows, terms, cols, getCellValue) => {
      return rows.filter((row) => {
        return (
          filterBroker.value.broker === "" ||
          row.seller?.toLowerCase() === filterBroker.value ||
          row.buyer?.toLowerCase() === filterBroker.value
        );
      });
    };

    function calculateQuantityTotal(data) {
      const totalQuantity = data.reduce(
        (total, item) => total + item.quantity,
        0
      );
      return data.map((item) => ({ ...item, quantity_total: totalQuantity }));
    }

    function getData() {
      //-----------TOP BUYER STOCK ------------------//
      // buyerStockDayWise(0, props.symbol)
      //   .then((res) => {
      // topBuyDaily.value =calculateQuantityTotal(res.data);
      //     // loading.value = false;
      //   })
      //   .then(() => {
      // });
      buyerStockDayWise(5, props.symbol)
        .then((res) => {
          topBuyWeekly.value = calculateQuantityTotal(res.data);
          loading.value = false;
        })
        .then(() => {
          buyerStockDayWise(21, props.symbol).then((res) => {
            topBuyMonthly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        // .then(() => {
        //   //------------SELLER-STOCK-------------------//
        //   sellerStockDayWise(0, props.symbol).then((res) => {
        //     // topSellDaily.value = calculateQuantityTotal(res.data);
        //     // loading.value = false;
        //   });
        // })
        .then(() => {
          sellerStockDayWise(5, props.symbol).then((res) => {
            topSellWeekly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        .then(() => {
          sellerStockDayWise(21, props.symbol).then((res) => {
            topSellMonthly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        // .then(() => {
        //   //-----------NETHOLDINDAYWISE--------//
        //   netHoldingDayWise(0, props.symbol).then((res) => {
        //     // netHoldDaily.value = calculateQuantityTotal(res.data);
        //     // loading.value = false;
        //   });
        // })
        .then(() => {
          netHoldingDayWise(5, props.symbol).then((res) => {
            netHoldWeekly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        .then(() => {
          netHoldingDayWise(21, props.symbol).then((res) => {
            netHoldMonthly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        // .then(() => {
        //   //-----------------NET RELEASED-----------------------//
        //   netReleasedDayWise(0, props.symbol).then((res) => {
        //     // netReleasedDaily.value = calculateQuantityTotal(res.data);
        //     // loading.value = false;
        //   });
        // })
        .then(() => {
          netReleasedDayWise(5, props.symbol).then((res) => {
            netReleasedWeekly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        .then(() => {
          netReleasedDayWise(21, props.symbol).then((res) => {
            netReleasedMonthly.value = calculateQuantityTotal(res.data);
            loading.value = false;
          });
        })
        .then(() => {
          selectedSymbol.value = seriesData()[0].symbol;
        });
    }

    function seriesData() {
      return tabPeriod.value == "daily" &&
        tabAction.value == "top-bought" &&
        topBuyDaily.value
        ? topBuyDaily.value
        : tabPeriod.value == "daily" &&
          tabAction.value == "top-sold" &&
          topSellDaily.value
        ? topSellDaily.value
        : tabPeriod.value == "daily" &&
          tabAction.value == "top-net-holding" &&
          netHoldDaily.value
        ? netHoldDaily.value
        : tabPeriod.value == "daily" &&
          tabAction.value == "top-net-released" &&
          netReleasedDaily.value
        ? netReleasedDaily.value
        : tabPeriod.value == "weekly" &&
          tabAction.value == "top-bought" &&
          topBuyWeekly.value
        ? topBuyWeekly.value
        : tabPeriod.value == "weekly" &&
          tabAction.value == "top-sold" &&
          topSellWeekly.value
        ? topSellWeekly.value
        : tabPeriod.value == "weekly" &&
          tabAction.value == "top-net-holding" &&
          netHoldWeekly.value
        ? netHoldWeekly.value
        : tabPeriod.value == "weekly" &&
          tabAction.value == "top-net-released" &&
          netReleasedWeekly.value
        ? netReleasedWeekly.value
        : tabPeriod.value == "monthly" &&
          tabAction.value == "top-bought" &&
          topBuyMonthly.value
        ? topBuyMonthly.value
        : tabPeriod.value == "monthly" &&
          tabAction.value == "top-sold" &&
          topSellMonthly.value
        ? topSellMonthly.value
        : tabPeriod.value == "monthly" &&
          tabAction.value == "top-net-holding" &&
          netHoldMonthly.value
        ? netHoldMonthly.value
        : tabPeriod.value == "monthly" &&
          tabAction.value == "top-net-released" &&
          netReleasedMonthly.value
        ? netReleasedMonthly.value
        : [];
    }

    function getSeries(brokerData) {
      return [
        {
          data: brokerData.slice(0, 10).map((bd) => {
            return {
              x: bd.symbol,
              y: bd.amount,
            };
          }),
        },
      ];
    }

    function getStockSeries(brokerData, symbol) {
      const bysymbol = brokerData.reduce((acc, curr) => {
        const symbol = curr.symbol;
        const broker = curr.buyer ?? curr.seller;
        if (!acc[symbol]) {
          acc[symbol] = [];
        }
        acc[symbol].push(curr);
        return acc;
      }, {});

      return [
        {
          data: bysymbol[symbol].slice(0, 10).map((bd) => {
            return {
              x: bd.buyer ?? bd.seller,
              y: bd.amount,
            };
          }),
        },
      ];
    }

    const chartOptions = {
      chart: {
        type: "bar",
        height: 250,
        stacked: true,
        toolbar: {
          show: false,
        },

        events: {
          dataPointSelection: function (event, chartContext, config) {
            const dp = config.dataPointIndex;

            selectedSymbol.value = chartContext.data.twoDSeriesX[dp];

            elSymbolChart = document.querySelector("#chart-by-symbol");
            if (elSymbolChart) {
              elSymbolChart.innerHTML = null;
              chartInstance.value = new ApexChart(elSymbolChart, {
                ...chartOptions,
                series: getStockSeries(seriesData(), selectedSymbol.value),
              });
              chartInstance.value.render();
            }
          },
        },
      },

      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      yaxis: {
        title: {
          // text: "Amount",
        },
      },
      xaxis: {
        title: {
          // text: "Stock Symbol",
        },
      },
    };

    watch([tabPeriod, tabAction, tabDisplay, props], ([a, b, c], [d, e, f]) => {
      getData();
      setTimeout(() => {
        elOverallChart = document.querySelector("#chart-overall");
        if (elOverallChart) {
          elOverallChart.innerHTML = null;
          overallChartInstance.value = new ApexChart(elOverallChart, {
            ...chartOptions,
            series: getSeries(seriesData()),
          });
          overallChartInstance.value.render();
        }

        elSymbolChart = document.querySelector("#chart-by-symbol");
        if (elSymbolChart) {
          elSymbolChart.innerHTML = null;
          selectedSymbol.value = seriesData()[0].symbol;
          chartInstance.value = new ApexChart(elSymbolChart, {
            ...chartOptions,
            series: getStockSeries(seriesData(), selectedSymbol.value),
          });
          chartInstance.value.render();
        }
      }, 100);
    });

    function loadData(date, symbol) {
      buyerStockDateWise(
        date.replaceAll("/", "-"),
        date.replaceAll("/", "-"),
        symbol
      ).then((res) => {
        topBuyDaily.value = calculateQuantityTotal(res.data);
      });
      sellerStockDateWise(
        date.replaceAll("/", "-"),
        date.replaceAll("/", "-"),
        symbol
      ).then((res) => {
        topSellDaily.value = calculateQuantityTotal(res.data);
      });
      netHoldingDateWise(
        date.replaceAll("/", "-"),
        date.replaceAll("/", "-"),
        symbol
      ).then((res) => {
        netHoldDaily.value = calculateQuantityTotal(res.data);
      });
      netReleasedDateWise(
        date.replaceAll("/", "-"),
        date.replaceAll("/", "-"),
        symbol
      ).then((res) => {
        netReleasedDaily.value = calculateQuantityTotal(res.data);
      });
    }

    watch(props, (newVal, oldVal) => {
      loadData(selectedDate.value, newVal.symbol);
    });

    onMounted(() => {
      selectedDate.value = store.state.market.asOf;
      loadData(selectedDate.value, props.symbol);
      getData();
    });

    return {
      tabPeriod,
      tabAction,
      tabDisplay,

      columnsBuy,
      columnsSell,

      loading,
      selectedSymbol,

      filterBroker,
      filterBrokerAnalytics,

      netHold,

      netHoldDaily,
      netHoldWeekly,
      netHoldMonthly,

      netReleasedDaily,
      netReleasedWeekly,
      netReleasedMonthly,

      topBuyDaily,
      topBuyWeekly,
      topBuyMonthly,

      topSellDaily,
      topSellWeekly,
      topSellMonthly,

      chartOptions,
      getSeries,
      seriesData,
      getStockSeries,

      sumBy,
      meanBy,

      selectedDate,
      loadData,
    };
  },
};
</script>
